import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { roles } from "utils/constant";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import {
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ArrowUpIcon,
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
} from "@heroicons/react/24/outline";
import { get_file_url } from "utils/lib-utils";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { Button } from "@heroui/react";

const ExpenseVouchureList: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const [tableData, setTableData] = useState<any>([]);
  const [agentId, setAgentId] = useState("");
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [query, setQuery] = useState<any>({
    date: {
      $gte: moment().startOf("day"),
      $lte: moment().endOf("day"),
    },
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);
  const [sortStat, setSortStat] = useState<any>({});

  const [selectedAgent, setSelectedAgent] = useState({ id: null, name: "--- Select All ---" });
  const [allAgents, setAllAgents] = useState([]);

  const [selectedVouchers, setSelectedVouchers] = useState<any>([]);
  const [selectedTotal, setSelectedTotal] = useState<any>(0);
  const [firstVoucherStatus, setFirstVoucherStatus] = useState<string>("");

  const [selectedStatus, setSelectedStatus] = useState({ value: "", label: "--- Select All ---" });
  const [allStatusList, setAllStatusList] = useState([
    { value: "", label: "--- Select All ---" },
    { value: "PENDING", label: "Pending By Both" },
    { value: "APPROVED", label: "Approve By Manager, Pending By Acc." },
    { value: "DISBURSED", label: "Disbursed" },
    { value: "REJECTED", label: "Rejected / Cancel" },
  ]);

  useEffect(() => {
    let total = 0;
    let status = "";
    if (tableData.length) {
      tableData.forEach((t) => {
        if (selectedVouchers.includes(t.id)) {
          total += Number(t.expense);
          status = t.status;
        }
      });
      setSelectedTotal(total);
      setFirstVoucherStatus(status);
    }
  }, [selectedVouchers]);

  useEffect(() => {
    const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
    if (Object.keys(userD).length) {
      setUserDetails(userD.state.user);
      if (userD.state.user.roleName == roles.SUPER_ADMIN) {
        mutateListAgents({ subbranch: undefined });
      } else if (userD.state.user.roleName == roles.SUBBRANCH_ADMIN) {
        mutateListAgents({ subbranch: userD.state.user?.subbranch });
      } else {
        mutateListAgents({ subbranch: undefined });
      }
    }
  }, []);

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_expense_vouchure_list"],
    () =>
      ListCommanWay("/admin/expense_vouchure/list", query, {
        include: ["_user"],
      }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          setTableData(data.data.data);
          setSortStat({});
          setSelectedVouchers([]);
          setSelectedTotal(0);
          setFirstVoucherStatus("");
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    }
  );

  const { mutate: mutateListAgents }: any = useMutation(
    (qry: any) => ListCommanWay("/admin/user/list", { subbranch: qry?.subbranch, isActive: true }, { paginate: 100000 }),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          setAllAgents([{ id: null, name: "--- Select All ---" }, ...data.data.data]);
        }
      },
      onError: (data: any) => {},
    }
  );

  const {
    mutate,
    isLoading: isloadingPrice,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((data) => UpdateCommanWay(data), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        refetch();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });
  const onStateChange = (id: any, status) => {
    Swal.fire({
      title: "Are you sure!",
      text: "Changing Status to : " + status,
      icon: "info",
      confirmButtonText: "Yes",
      showCancelButton: true,
      html:
        '<input id="user_remark" class="swal2-input" placeholder="Enter Remark">' +
        '<input id="transactionNo" class="swal2-input" placeholder="Transaction No">',
    }).then((x) => {
      if (x.isConfirmed) {
        let updateData: any = {
          account_remark: undefined,
          transactionNo: (document.getElementById("transactionNo") as any).value,
          account_date: undefined,
          status: status,
        };
        if (userDetails.role_name == 9 || userDetails.role_name == 3) {
          updateData.admin_remark = (document.getElementById("user_remark") as any).value;
          updateData.admin_date = new Date();
        } else {
          updateData.account_remark = (document.getElementById("user_remark") as any).value;
          updateData.account_date = new Date();
          if (updateData.transactionNo == "") {
            delete updateData.transactionNo;
          }
        }
        if (typeof id == "object") {
          mutate({
            url: "/admin/expense_vouchure/updateBulk",
            data: {
              filter: { id: selectedVouchers },
              data: updateData,
            },
          });
        } else {
          mutate({
            url: "/admin/expense_vouchure/update/" + id,
            data: updateData,
          });
        }
      }
    });
  };

  const onGstInfoChange = (id: any) => {
    Swal.fire({
      title: "Add GST Details!",
      icon: "info",
      confirmButtonText: "Yes",
      showCancelButton: true,
      html:
        //inputs for cgst, sgst, igst
        '<input style="height: 1.5em; margin: 4px;" id="cgst" class="swal2-input" placeholder="CGST (%)">' +
        '<input style="height: 1.5em; margin: 4px;" id="sgst" class="swal2-input" placeholder="SGST (%)">' +
        '<input style="height: 1.5em; margin: 4px;" id="igst" class="swal2-input" placeholder="IGST (%)">' +
        '<input style="height: 1.5em; margin: 4px;" id="customerGstNo" class="swal2-input" placeholder="Customer GST No">' +
        '<input style="height: 1.5em; margin: 4px;" id="airfieldGstNo" class="swal2-input" placeholder="Airfield GST NO">',
    }).then((x) => {
      if (x.isConfirmed) {
        let updateData: any = {
          cgst: Number((document.getElementById("cgst") as any).value) || 0,
          sgst: Number((document.getElementById("sgst") as any).value) || 0,
          igst: Number((document.getElementById("igst") as any).value) || 0,
          customerGstNo: (document.getElementById("customerGstNo") as any).value || "",
          airfieldGstNo: (document.getElementById("airfieldGstNo") as any).value || "",
        };
        if (typeof id == "object") {
          mutate({
            url: "/admin/expense_vouchure/updateBulk",
            data: {
              filter: { id: selectedVouchers },
              data: updateData,
            },
          });
        } else {
          mutate({
            url: "/admin/expense_vouchure/update/" + id,
            data: updateData,
          });
        }
      }
    });
  };

  useEffect(() => {
    refetch();
  }, [query]);

  const handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);
    setQuery({
      //agent_id: Number(agentId),
      date: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days"),
        $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
      },
      user: selectedAgent.id ? selectedAgent.id : undefined,
      status: selectedStatus.value == "" ? undefined : selectedStatus.value,
    });
  };

  const tableRef = useRef(null);
  const exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Expense Vouchure Report.xlsx");
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    if (key == "_invoice_no_c_b.isFullPaid") {
      data = data.sort((a, b) => {
        if (order == "asc") {
          return -a["isActive"] + b["isActive"];
        } else {
          return -b["isActive"] + a["isActive"];
        }
      });
    }

    let sortedData = data.sort((a, b) => {
      // Extract the value using the keyPath (e.g., "invoice_data.idpaid")
      const valueA = key.split(".").reduce((obj, key) => obj[key], a);
      const valueB = key.split(".").reduce((obj, key) => obj[key], b);
      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  return (
    <>
      <h1 className="text-center mb-3 mt-3 text-lg font-semibold ">Expense Vouchure</h1>
      <div className="flex items-end flex-col gap-4 px-4 pb-2 rounded-md">
        {/*<div className="flex gap-4 w-full flex-1">
          <label className="w-full text-sm font-semibold text-gray-900">
            Agent
          </label>
          <input
            type="number"
            className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
            placeholder="Agent ID"
            name="agent_id"
            value={agentId}
            onBlur={(e) => {
              setAgentId(e.target.value);
              if (!e.target.value) {
                setQuery({});
              }
            }}
            onChange={(e) => {
              setAgentId(e.target.value);
              if (!e.target.value) {
                setQuery({});
              }
            }}
            onWheel={handleWheel}
          />
          </div>*/}
        <div className="flex gap-1 items-center flex-wrap border p-2 rounded-xl bg-gray-200 border-blue-600 w-full">
          {[1, 2, 3, 5, 9].includes(userDetails.role_name) && (
            <div className={`inline-flex items-center gap-2 mr-6`}>
              <label className="text-sm font-semibold text-gray-900 whitespace-nowrap">Select Employee</label>
              <Select
                className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-52 `}
                options={allAgents}
                onChange={(e: any) => {
                  setSelectedAgent(e);
                }}
                value={selectedAgent}
                getOptionValue={(e) => {
                  return e.id + "";
                }}
                getOptionLabel={(e) => {
                  return e.name;
                }}
              />
            </div>
          )}

          <div className={`inline-flex items-center gap-2`}>
            <label className="text-sm font-semibold text-gray-900 whitespace-nowrap">Select Status</label>
            <Select
              className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full `}
              options={allStatusList}
              onChange={(e: any) => {
                setSelectedStatus(e);
              }}
              value={selectedStatus}
            />
          </div>

          <div className="flex items-center ml-12 gap-4">
            <div className="flex gap-4 w-full flex-1 items-center">
              <label className=" text-sm font-semibold text-gray-900 whitespace-nowrap">From Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-36 p-2.5`}
                placeholder="Start Date"
                name="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="flex gap-4 w-full flex-1 items-center">
              <label className="text-sm font-semibold text-gray-900 whitespace-nowrap">To Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-36 p-2.5`}
                placeholder="End Date"
                name="endDate"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>

          <button
            type="button"
            onClick={handleSubmit}
            className="ml-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
          >
            Submit
          </button>
          <button onClick={exportToExcel} className=" bg-blue-600 text-white px-4 py-1 rounded-md">
            Excel Export
          </button>
        </div>
      </div>
      <div className="px-4">
        {selectedTotal >= 0 && (
          <div className="text-center mb-4 flex justify-center items-center gap-10">
            <p className={`font-medium text-2xl underline`}>
              Selected Total: <b> {selectedTotal}</b>
            </p>

            <div className="flex items-center justify-center gap-1">
              <button
                type="button"
                onClick={() => {
                  onStateChange(selectedVouchers, userDetails.role_name == 9 || userDetails.role_name == 3 ? "APPROVED" : "DISBURSED");
                }}
                disabled={selectedTotal == 0}
                className={`ml-2 rounded-md px-4 py-2 font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 ${
                  selectedTotal == 0 ? "bg-gray-300 pointer-events-none" : ""
                }`}
              >
                {userDetails.role_name == 9 || userDetails.role_name == 3 ? "Bulk Approve" : "Bulk Disbursed"}
              </button>
              <button
                type="button"
                onClick={() => {
                  onStateChange(selectedVouchers, "REJECTED");
                }}
                className={`ml-2 rounded-md px-4 py-2 font-medium text-white bg-red-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 ${
                  selectedTotal == 0 ? "bg-gray-300 pointer-events-none" : ""
                }`}
              >
                Bulk Reject
              </button>

              <Button
                className="ml-2"
                size="md"
                color="primary"
                variant="bordered"
                onPress={() => {
                  onGstInfoChange(selectedVouchers);
                }}
              >
                Add GST Info
              </Button>
            </div>
          </div>
        )}
        <table className="w-full table- mb-4 font-inter" id="myTable" ref={tableRef}>
          <thead>
            <tr>
              {[1, 2, 3, 5, 9].includes(userDetails.role_name) && (
                <th className="border border-slate-200">
                  <input
                    type="checkbox"
                    className="focus:border-black-900"
                    onChange={(ip) => {
                      let checked_ = ip.target.checked;
                      console.log(checked_);
                      if (checked_ && tableData.length) {
                        let firstStatus = tableData[0].status;
                        let obj = [];
                        tableData.forEach((x) => {
                          if (x.status == firstStatus) {
                            obj.push(x.id);
                          }
                        });
                        setSelectedVouchers(obj);
                      } else {
                        setSelectedVouchers([]);
                      }
                    }}
                    checked={selectedVouchers.length}
                  />
                  Check
                </th>
              )}

              <th className="border border-slate-200">Transaction No</th>
              <th className="border border-slate-200">User {GET_SORT_ICON("_user.name", "asc")}</th>
              <th className="border border-slate-200">Head</th>
              <th className="border border-slate-200">Amount</th>
              <th className="border border-slate-200 w-32">Expense Date {GET_SORT_ICON("date", "")}</th>
              <th className="border border-slate-200 w-32">Submit Date {GET_SORT_ICON("createdAt", "")}</th>
              <th className="border border-slate-200 w-28">Image</th>
              <th className="border border-slate-200">Status {GET_SORT_ICON("status", "")}</th>
              <th className="border border-slate-200">Manager Remark</th>
              <th className="border border-slate-200">Account Remark</th>
              <th className="border border-slate-200">GST Info</th>
              {[1, 2, 3, 5, 9].includes(userDetails.role_name) && <th className="border border-slate-200 w-24">ACTION</th>}
            </tr>
          </thead>
          <tbody className="text-sm">
            {tableData.map((r) => {
              return (
                <tr
                  style={{
                    backgroundColor:
                      r.status != "PENDING" && (r.status == "APPROVED" ? "#60b9ff" : r.status == "REJECTED" ? "#ff6a5f" : "#57ca5c"),
                  }}
                  className={`${selectedVouchers.includes(r.id) ? "bg-primary_light2" : "bg-white"}`}
                >
                  {[1, 2, 3, 5, 9].includes(userDetails.role_name) && (
                    <td className="border border-slate-200 px-4">
                      {r.status != "REJECTED" &&
                      (selectedVouchers.length == 0 || (selectedVouchers.length && firstVoucherStatus == r.status)) ? (
                        <input
                          type="checkbox"
                          className="focus:border-black-900"
                          onChange={(ip) => {
                            if (ip.target.checked) {
                              let obj = [...selectedVouchers];
                              obj.push(r.id);
                              setSelectedVouchers(obj);
                            } else {
                              let obj = [...selectedVouchers];
                              const index = obj.indexOf(r.id);
                              if (index > -1) {
                                obj.splice(index, 1);
                              }
                              setSelectedVouchers(obj);
                            }
                          }}
                          checked={selectedVouchers.includes(r.id)}
                        />
                      ) : (
                        <p>-</p>
                      )}
                    </td>
                  )}

                  <td className="border border-slate-200 px-2">{r.transactionNo}</td>
                  <td className="border border-slate-200 px-2">{r._user?.name}</td>
                  <td className="border border-slate-200 px-2">{r.remark}</td>
                  <td className="border border-slate-200 px-2">{r.expense}</td>
                  <td className="border border-slate-200 px-2">{r.date}</td>
                  <td className="border border-slate-200 px-2">{r.createdAt}</td>

                  <td className="border border-slate-200 px-2">
                    <PhotoProvider
                      toolbarRender={({ rotate, onRotate }) => {
                        return (
                          <div className="flex gap-4 bg-gray-200/25 p-2 rounded-md ">
                            <button onClick={() => onRotate(rotate - 90)}>
                              <ArrowUturnLeftIcon className="PhotoView-Slider__toolbarIcon fill-none h-6 p-0" />
                            </button>
                            <button onClick={() => onRotate(rotate + 90)}>
                              <ArrowUturnRightIcon className="PhotoView-Slider__toolbarIcon fill-none h-6 p-0" />
                            </button>
                          </div>
                        );
                      }}
                    >
                      {r.image
                        ? r.image.split(",").map((i) => {
                            return (
                              <div className="flex mb-1 bg-slate-400/50 rounded-md p-1" key={i} >
                                <PhotoView src={get_file_url(i)}>
                                  <img width={80} className="h-[80px] object-cover" src={get_file_url(i)} />
                                </PhotoView>
                                <a href={get_file_url(i)} target="_blank" rel="noopener noreferrer">
                                  <ArrowTopRightOnSquareIcon className="h-5 -mb-1 ml-2" />
                                </a>
                              </div>
                            );
                          })
                        : "-"}
                    </PhotoProvider>
                  </td>
                  <td className="border border-slate-200 px-2">{r.status}</td>
                  <td className="border border-slate-200 px-2">
                    {r.admin_remark}
                    <br /> <b className="text-sm">{r.admin_date && moment(r.admin_date).format("DD-MM-YYYY HH:mm")}</b>
                  </td>
                  <td className="border border-slate-200 px-2">
                    {r.account_remark}
                    <br /> <b className="text-sm">{r.account_date && moment(r.account_date).format("DD-MM-YYYY HH:mm")}</b>
                  </td>
                  <td className="border border-slate-200 px-2">
                    {(r.cgst || r.sgst || r.igst) && (
                      <div className="font-semibold text-sm">
                        <div className="whitespace-nowrap">C: {r.cgst || 0}</div>
                        <div className="whitespace-nowrap">S: {r.sgst || 0}</div>
                        <div className="whitespace-nowrap">I: {r.igst || 0}</div>
                        <div className="text-xs border-t">AF:{r.airfieldGstNo || "-"}</div>
                        <div className="text-xs">C:{r.customerGstNo || "-"}</div>
                      </div>
                    )}
                  </td>
                  {[1, 2, 3, 5, 9].includes(userDetails.role_name) && (
                    <td className="border border-slate-200 px-2">
                      {r.status == (userDetails.role_name == 9 || userDetails.role_name == 3 ? "PENDING" : "APPROVED") && (
                        <div className="flex flex-col items-center justify-center gap-1">
                          <button
                            type="button"
                            onClick={() => {
                              onStateChange(r.id, userDetails.role_name == 9 || userDetails.role_name == 3 ? "APPROVED" : "DISBURSED");
                            }}
                            className="ml-2 rounded-md px-3 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                          >
                            {userDetails.role_name == 9 || userDetails.role_name == 3 ? "Approve" : "Disburse"}
                          </button>
                        </div>
                      )}

                      {
                        /*r.status == (userDetails.role_name == 5 ? "APPROVED" : "PENDING") &&*/
                        r.status != "REJECTED" && (
                          <div className="flex flex-col items-center justify-center gap-1">
                            <button
                              type="button"
                              onClick={() => {
                                onStateChange(r.id, "REJECTED");
                              }}
                              className="ml-2 rounded-md px-3 py-1 text-sm font-medium text-white bg-red-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                            >
                              Reject
                            </button>
                          </div>
                        )
                      }
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ExpenseVouchureList;
